import React from 'react';
import ReactDOM from 'react-dom/client';

import { GlobalStyle } from './styles';
import { App } from './App';
import { StateContextProvider, GoogleMapsContextProvider } from './context';
import { loadGoogleMaps } from './utils';
import { initI18n, i18n } from 'locale/i18n';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

initI18n()
    .then(() => {
        const language = i18n.language || 'nl';

        if (typeof document !== 'undefined') {
            document.documentElement.setAttribute('lang', language);
        }

        return loadGoogleMaps(language);
    })
    .then(() => {
        root.render(
            <React.StrictMode>
                <StateContextProvider>
                    <GoogleMapsContextProvider>
                        <GlobalStyle />
                        <App />
                    </GoogleMapsContextProvider>
                </StateContextProvider>
            </React.StrictMode>
        );
    });
